import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, unref as _unref, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2277524e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "flex-col flex"
}
const _hoisted_2 = { class: "qr-scanner" }
const _hoisted_3 = {
  key: 0,
  class: "center"
}
const _hoisted_4 = {
  key: 2,
  class: "dropdown"
}
const _hoisted_5 = { class: "ml-xs" }
const _hoisted_6 = {
  key: 0,
  class: "flex items-center overflow-scroll space-x-xs mb-xs w-full",
  style: {"width":"300px"}
}
const _hoisted_7 = { key: 1 }

import { ref, onMounted, onBeforeUnmount } from "vue";
import { BrowserMultiFormatReader } from "@zxing/browser";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import { MedicationOrderBoxStatus } from "@/interfaces/enum/medicationOrderStatus";
import ProgressDot from "@/components/ProgressDot.vue";
import UButton from "@/components/UButton.vue";
import { useNotificationStore } from "@/store/notificationStore";


export default /*#__PURE__*/_defineComponent({
  __name: 'QrScanner',
  props: {
    requestStatus: { type: Boolean },
    onQrScanned: { type: Function }
  },
  setup(__props: any) {

const videoStream = ref<MediaStream | null>(null);
const hints = new Map();

const loading = ref<boolean>(false);
const savingBox = ref<boolean>(false);
const devices = ref<InputDeviceInfo[]>([]); // eslint-disable-line
const currentDeviceId = ref<string>("");
const chooseStatus = ref<boolean>(false);
const codeReader = new BrowserMultiFormatReader(hints);
const video = ref<HTMLVideoElement | null>(null);
const canvas = ref<HTMLCanvasElement | null>(null);
const props = __props;

const message = ref<{ msg: string; success: boolean } | null>(null);
let lastQrCode = "";
let ctx: CanvasRenderingContext2D | undefined | null;
let flipped = false;

async function updateBox(status: number) {
  savingBox.value = true;
  chooseStatus.value = false;

  const res2 = await props.onQrScanned(lastQrCode, status);
  message.value = res2;
  lastQrCode = "";
  savingBox.value = false;
}

function abort() {
  chooseStatus.value = false;
  lastQrCode = "";
  savingBox.value = false;
}
async function drawFrame() {
  if (canvas.value && video.value) {
    if (ctx == null) return;
    const videoW = video.value.videoWidth;
    const videoH = video.value.videoHeight;
    const moveX = (videoW - 300) / 2;
    const moveY = (videoH - 300) / 2;
    if (flipped) {
      ctx?.scale(-1, 1); // Flip horizontally
      canvas.value.style.opacity = "0";

      ctx.drawImage(
        video.value,
        -canvas.value.width - moveX,
        -moveY,
        videoW,
        videoH
      );
    } else {
      canvas.value.style.opacity = "1";
      ctx?.scale(1, 1); // Flip horizontally
      ctx.drawImage(video.value, -moveX, -moveY, videoW, videoH);
    }
    flipped = !flipped;

    try {
      const res = codeReader.decodeFromCanvas(canvas.value);
      // ctx.drawImage(video.value, -moveX, -moveY, 300, 300);
      if (res.getText() != lastQrCode) {
        if (props.requestStatus) {
          chooseStatus.value = true;
          lastQrCode = res.getText();
        } else {
          await props.onQrScanned(res.getText(), 0);
        }
      }
    } catch (e) {
      //ignore
      if (`${e}`.toLocaleLowerCase().includes("Permission denied")) {
        useNotificationStore().notifications.push({
          msg: `Fehler - Es kann nicht auf die Kamera zugegriffen werden. Bitte Berechtigungen prüfen.`,
          type: "danger",
        });
      }
    }
    requestAnimationFrame(drawFrame);
  }
}

const shortName = (name: string) => {
  return name;
};

const initScanner = async (newPreferId?: string) => {
  window._paq.push(["trackEvent", "QRScanner", "opened"]);

  if (!video.value || !canvas.value) return;
  if (videoStream.value) {
    videoStream.value.getTracks().forEach((track) => track.stop());
  }
  const preferId = newPreferId ?? localStorage.getItem("preferCam") ?? "";

  try {
    const stream = await navigator.mediaDevices.getUserMedia({
      video:
        preferId === ""
          ? { facingMode: "environment" }
          : { deviceId: preferId },
    });

    if (navigator.mediaDevices && navigator.mediaDevices.enumerateDevices) {
      devices.value = (await navigator.mediaDevices.enumerateDevices())
        .filter((device) => device.kind == "videoinput")
        .sort((a, b) => (a.label > b.label ? -1 : 1));
    }
    currentDeviceId.value = preferId;
    localStorage.setItem("preferCam", preferId);

    video.value.srcObject = stream;
    videoStream.value = stream;
    const videoWidth = 300;
    const videoHeight = 50;

    video.value.setAttribute("width", videoWidth.toString());
    video.value.setAttribute("height", videoHeight.toString());

    ctx = canvas.value.getContext("2d", { willReadFrequently: true });

    drawFrame();
  } catch (error) {
    console.error("Error accessing camera:", error);
  }
};

onMounted(initScanner);

onBeforeUnmount(() => {
  if (videoStream.value) {
    videoStream.value.getTracks().forEach((track) => track.stop());
  }
});

return (_ctx: any,_cache: any) => {
  return (!loading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("canvas", {
            ref_key: "canvas",
            ref: canvas,
            width: "300",
            height: "300",
            style: {"display":"none"}
          }, null, 512),
          (savingBox.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(LoadingSpinner, { class: "loader" })
              ]))
            : _createCommentVNode("", true),
          (message.value && message.value.msg != '')
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass(["notification p-xs", { success: message.value.success, fail: !message.value.success }]),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (message.value = null))
              }, _toDisplayString(message.value.msg), 3))
            : _createCommentVNode("", true),
          _createElementVNode("video", {
            ref_key: "video",
            ref: video,
            playsinline: "",
            autoplay: ""
          }, null, 512),
          (chooseStatus.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(MedicationOrderBoxStatus), (status) => {
                    return (_openBlock(), _createBlock(UButton, {
                      key: status.id,
                      onClick: ($event: any) => (updateBox(status.id)),
                      color: "white",
                      class: "w-full my-xs"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(ProgressDot, {
                          progress: status.progress
                        }, null, 8, ["progress"]),
                        _createElementVNode("div", _hoisted_5, _toDisplayString(status.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  }), 128)),
                  _createVNode(UButton, {
                    onClick: abort,
                    color: "white",
                    class: "w-full my-xs"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Abbrechen ")
                    ]),
                    _: 1
                  })
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        (devices.value.length > 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(devices.value, (device) => {
                return (_openBlock(), _createBlock(UButton, {
                  color: currentDeviceId.value == device.deviceId ? 'orange' : 'white',
                  onClick: ($event: any) => (initScanner(device.deviceId)),
                  key: device.deviceId,
                  class: "flex-1"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(shortName(device.label)), 1)
                  ]),
                  _: 2
                }, 1032, ["color", "onClick"]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_7, [
        _createVNode(LoadingSpinner)
      ]))
}
}

})